import { Copy } from "lucide-react";
import PropTypes from "prop-types";
import { HiDotsHorizontal } from "react-icons/hi";
import { RowActionsMenu } from "../../../../components/data-table";

const CouponCodeMobileCard = ({
    coupon,
    copied,
    onCopy,
    menuItems,
    onMenuClick,
    discountLabel,
    rows,
}) => (
    <article className="rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
        <div className="flex items-start justify-between gap-3">
            <div className="flex min-w-0 flex-1 items-center gap-2">
                <span className="break-all text-base font-semibold text-[#5D5DF6]">{coupon?.code || "N/A"}</span>
                <button
                    type="button"
                    onClick={onCopy}
                    className={`shrink-0 rounded-md p-1 ${
                        !coupon?.code || coupon.code === "N/A"
                            ? "cursor-not-allowed text-gray-300"
                            : "text-gray-500 hover:text-blue-600 active:text-blue-700"
                    }`}
                    disabled={!coupon?.code || coupon.code === "N/A"}
                    aria-label="Copy coupon code">
                    <Copy size={16} className={copied ? "text-green-500" : ""} />
                </button>
            </div>
            <RowActionsMenu
                items={menuItems}
                onClick={(info) => onMenuClick(info, coupon)}
                label="Actions"
                icon={<HiDotsHorizontal size={18} />}
                className="!h-8 !w-8 shrink-0 !rounded-full text-gray-500"
            />
        </div>
        {coupon?.description ? (
            <p className="mt-2 text-sm text-gray-600">{coupon.description}</p>
        ) : (
            <p className="mt-2 text-sm text-gray-400">N/A</p>
        )}
        <dl className="mt-3 space-y-2 border-t border-gray-100 pt-3">
            <div className="flex items-start justify-between gap-3 text-sm">
                <dt className="text-gray-500">Discount</dt>
                <dd className="text-right font-medium text-[#2F2F46]">{discountLabel}</dd>
            </div>
            {rows.map(({ label, value }) => (
                <div key={label} className="flex items-start justify-between gap-3 text-sm">
                    <dt className="shrink-0 text-gray-500">{label}</dt>
                    <dd className="min-w-0 text-right font-medium text-[#2F2F46]">{value}</dd>
                </div>
            ))}
        </dl>
    </article>
);

CouponCodeMobileCard.propTypes = {
    coupon: PropTypes.object.isRequired,
    copied: PropTypes.bool,
    onCopy: PropTypes.func.isRequired,
    menuItems: PropTypes.array.isRequired,
    onMenuClick: PropTypes.func.isRequired,
    discountLabel: PropTypes.node.isRequired,
    rows: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.node.isRequired,
        }),
    ).isRequired,
};

export default CouponCodeMobileCard;
